import { t } from '../i18n/uk.js';

/** "Shown 51–100 of 240" with previous / next buttons (offset paging). */
export function Pager({
  offset,
  pageSize,
  total,
  onChange,
}: {
  offset: number;
  pageSize: number;
  total: number;
  onChange: (offset: number) => void;
}) {
  if (total <= pageSize) return null;
  const last = Math.min(offset + pageSize, total);
  return (
    <div className="actions pager">
      <button
        type="button"
        disabled={offset === 0}
        onClick={() => onChange(Math.max(offset - pageSize, 0))}
      >
        {t.common.previous}
      </button>
      <span className="muted">
        {t.common.shown} {offset + 1}–{last} {t.common.of} {total}
      </span>
      <button type="button" disabled={last >= total} onClick={() => onChange(offset + pageSize)}>
        {t.common.next}
      </button>
    </div>
  );
}
